import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  getAll(eventId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/event/${eventId}/customers`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },

  get($, eventId = null, customerId = null, uuid = null) {
    return new Promise((resolve, reject) => {
      let root
      if (uuid) {
        root = `/event/customers/${uuid}`
      } else if (eventId) {
        root = `/event/${eventId}/customers${customerId ? "/" + customerId : ""}`
      } else {
        root = `/event/customers${customerId ? "/" + customerId : ""}`
      }
      HTTP.get(root)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },

  async getAllInspections() {
    const path = `/event/customers`
    return (await HTTP.get(path)).data
  },

  async exportExcel(eventId = null) {
    const path = eventId
      ? `/event/${eventId}/customers/export/excel`
      : `/event/customers/export/excel`
    const response = await HTTP.get(path, { responseType: "blob" })

    let filename = "clients.xlsx"
    const disposition = response.headers && response.headers["content-disposition"]
    if (disposition) {
      const match = disposition.match(/filename="?([^";]+)"?/i)
      if (match && match[1]) filename = match[1]
    }

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  },

  remove($, customerId) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/event/customers/${customerId}`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },

  create($, eventId, customer) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/event/${eventId}/customers`, customer)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  update($, customerId, customer) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/event/customers/${customerId}`, customer)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  createInspection($, eventId, customer) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/event/${eventId}/customers`, customer)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          let message = ""
          for (const err in error.response.data) {
            message += "- " + err + " : " + error.response.data[err] + "\n"
          }
          $.$store.commit("app/message", { msg: message, color: "error" })
          reject(error)
        })
    })
  },
  document: {
    async get($, customerId) {
      const path = `/documents/customers/${customerId}`
      const response = (await HTTP.get(path)).data
      if (response.length > 0) {
        return response[0]
      } else {
        throw Error("No template linked")
      }
    },
    async post(customerId, data) {
      const path = `/documents/customers/${customerId}`
      return (await HTTP.post(path, data)).data
    },
    async put(customerId, data) {
      const path = `/documents/customers/${customerId}`
      return (await HTTP.put(path, data)).data
    }
  },
  unassignedPictures: {
    getAll(customerId) {
      return new Promise((resolve, reject) => {
        HTTP.get(`/event/customers/${customerId}/unassigned-pictures`)
          .then(response => resolve(response.data))
          .catch(err => {
            return reject(err)
          })
      })
    },
    create(customerId, data) {
      return new Promise((resolve, reject) => {
        HTTP.post(`/event/customers/${customerId}/unassigned-pictures`, data)
          .then(response => resolve(response.data))
          .catch(err => {
            return reject(err)
          })
      })
    }
  }
}
